import React, { useState, useEffect, useRef } from "react";

const OnlyOfficeEditor = () => {
  const [selectedFile, setSelectedFile] = useState(null);
  const [isEditorLoaded, setIsEditorLoaded] = useState(false);
  const [apiStatus, setApiStatus] = useState("Ready");
  const [editorStatus, setEditorStatus] = useState("None");

  const docEditorRef = useRef(null);

  // OnlyOffice Configuration
  const serverUrl =
    "https://documentserver.ukwest.cloudapp.azure.com";

  const apiUrl =
    "https://ascensionqapi.azurewebsites.net/aqdocumentapi/api/";

  const files = [
    {
      id: 1,
      name: "Research_Key_Details.pdf",
      url: "https://ascensionblob.blob.core.windows.net/teststorage/2b144f21-78cc-43b3-b0b8-7d4f928f2eb8/MyVaultDocument/E97B9711-1516-428C-84CB-2CC624CB9365/77f1ba/CRF%20Review,%20Approval%20&%20Green%20Light%20of%20New%20Studies.pdf",
      size: "38 KB",
      modified: "2024-08-05",
      type: "pdf",
    },
    {
      id: 2,
      name: "Trial25Audit.xlsx",
      url: "https://ascensionblob.blob.core.windows.net/teststorage/fba496ac-0439-42f1-b9dc-f15a9821fece/MyVaultDocument/A6B47E3D-6010-4E59-8507-2C7E50D6341B/2109bc/Trial25Audit.xlsx",
      size: "38 KB",
      modified: "2024-08-05",
      type: "excel",
    },
    {
      id: 3,
      name: "Research_Key_Details.docx",
      url: "https://ascensionblob.blob.core.windows.net/teststorage/fba496ac-0439-42f1-b9dc-f15a9821fece/MyVaultDocument/DF6AA4A6-E864-43F5-A3C5-7DC0A32CFE8D/532065/Research_Key_Details.docx",
      size: "45 KB",
      modified: "2024-08-05",
      type: "word",
    },
  ];


  const getDocumentExtension = (filename) => {
    return filename
      .split(".")
      .pop()
      .toLowerCase();
  };


  const getDocumentType = (filename) => {

    const ext = getDocumentExtension(filename);

    switch (ext) {

      case "doc":
      case "docx":
        return "word";

      case "xls":
      case "xlsx":
        return "cell";

      case "ppt":
      case "pptx":
        return "slide";

      case "pdf":
        return "pdf";

      default:
        return "word";
    }
  };


  const getFileTypeLabel = (type) => {

    switch (type) {

      case "word":
        return "Word Document";

      case "excel":
        return "Excel Spreadsheet";

      case "powerpoint":
        return "PowerPoint Presentation";

      case "pdf":
        return "PDF Document";

      default:
        return "Document";
    }
  };


  const openInOnlyOffice = (file) => {

    if (selectedFile && docEditorRef.current) {
      cleanupEditor();
    }

    setSelectedFile(file);
    setIsEditorLoaded(false);
    setEditorStatus("Loading");
  };


  const cleanupEditor = () => {

    try {

      if (
        docEditorRef.current &&
        typeof docEditorRef.current.destroyEditor === "function"
      ) {
        docEditorRef.current.destroyEditor();
      }

    }
    catch (error) {
      console.log("Destroy editor error", error);
    }


    const container =
      document.getElementById("onlyoffice-editor");


    if (container) {
      container.innerHTML = "";
    }


    docEditorRef.current = null;
  };


  const closeEditor = () => {

    cleanupEditor();

    setSelectedFile(null);
    setIsEditorLoaded(false);
    setEditorStatus("None");
  };



  useEffect(() => {


    if (selectedFile && !isEditorLoaded) {


      const timer = setTimeout(() => {


        if (!window.DocsAPI) {


          const script = document.createElement("script");


          script.src =
            `${serverUrl}/web-apps/apps/api/documents/api.js`;


          script.onload = () => {
            initializeEditor();
          };


          script.onerror = () => {

            console.error(
              "OnlyOffice API loading failed"
            );

            setApiStatus("Error");
            setEditorStatus("Error");
          };


          document.head.appendChild(script);


        }
        else {

          initializeEditor();

        }


      }, 500);



      return () => clearTimeout(timer);

    }


  }, [selectedFile, isEditorLoaded]);





  const initializeEditor = () => {


    if (!selectedFile || !window.DocsAPI)
      return;



    const editorContainer =
      document.getElementById(
        "onlyoffice-editor"
      );


    if (editorContainer) {
      editorContainer.innerHTML = "";
    }



    try {


      const fileExtension =
        getDocumentExtension(
          selectedFile.name
        );



      const docEditor =
        new window.DocsAPI.DocEditor(

          "onlyoffice-editor",

          {


            document: {


              fileType: fileExtension,


              key:
                `AQ_DOCUMENT_${selectedFile.id}`,


              title: selectedFile.name,


              url: selectedFile.url,


              permissions: {

                edit: true,
                download: true,
                print: true,
                review: true,
                comment: true

              }

            },


            documentType:
              getDocumentType(
                selectedFile.name
              ),



            editorConfig: {


              mode: "edit",


              lang: "en",


              callbackUrl:
                `${apiUrl}onlyoffice/save?originalUrl=${encodeURIComponent(
                  selectedFile.url
                )}`,



              autosave: true,


              forcesave: true,


              user: {

                id: "user1",
                name: "AQ User"

              },


              customization: {

                autosave: false,
                forcesave: false,

                compactHeader: true,
                compactToolbar: true,

                hideRightMenu: true,
                hideLeftMenu: true,

                integrationMode: "embed",

                macros: false,

                chat: false,

                about: false,

                help: false,

                feedback: false,

                toolbarHideFileName: false,

                zoom: 100

              }

            },


            width: "100%",
            height: "100%",



            events: {


              onReady: () => {

                console.log(
                  "OnlyOffice Ready"
                );


                setIsEditorLoaded(true);
                setEditorStatus("Active");
                setApiStatus("Ready");

              },


              onDocumentReady: () => {

                console.log(
                  "Document loaded"
                );

                setIsEditorLoaded(true);
                setEditorStatus("Active");

              },


              onError: (event) => {

                console.error(
                  "OnlyOffice Error",
                  event
                );


                setEditorStatus("Error");

              }

            }


          }

        );



      docEditorRef.current =
        docEditor;



    }
    catch (error) {


      console.error(
        "Editor initialization failed",
        error
      );


      setEditorStatus("Error");

    }

  };
  useEffect(() => {

    return () => {
      cleanupEditor();
    };

  }, []);



  return (

    <div
      className="d-flex"
      style={{
        height: "100vh",
        fontFamily:
          '-apple-system,BlinkMacSystemFont,"Segoe UI",Roboto,sans-serif'
      }}
    >


      {/* LEFT DOCUMENT LIST */}

      <div
        style={{
          width: "380px",
          background: "#f8f9fa",
          borderRight: "1px solid #ddd",
          display: "flex",
          flexDirection: "column"
        }}
      >


        <div
          style={{
            padding: "20px",
            borderBottom: "1px solid #ddd"
          }}
        >

          <h4
            style={{
              margin: 0,
              fontWeight: 600
            }}
          >
            Documents
          </h4>

        </div>



        <div
          style={{
            flex: 1,
            overflowY: "auto",
            padding: "15px"
          }}
        >


          {
            files.map(file => (


              <div

                key={file.id}

                onClick={() =>
                  openInOnlyOffice(file)
                }


                style={{

                  background:
                    selectedFile?.id === file.id
                      ?
                      "#e3f2fd"
                      :
                      "#fff",


                  border:
                    selectedFile?.id === file.id
                      ?
                      "1px solid #2196f3"
                      :
                      "1px solid #ddd",


                  padding: "15px",
                  marginBottom: "10px",
                  borderRadius: "10px",
                  cursor: "pointer"

                }}

              >


                <div
                  style={{
                    fontWeight: 600,
                    fontSize: "14px"
                  }}
                >
                  {file.name}
                </div>


                <div
                  style={{
                    fontSize: "12px",
                    color: "#666",
                    marginTop: "5px"
                  }}
                >
                  {getFileTypeLabel(file.type)}
                  {" • "}
                  {file.size}
                </div>



              </div>


            ))
          }


        </div>




        <div
          style={{
            padding: "15px",
            background: "#fff",
            borderTop: "1px solid #ddd"
          }}
        >


          <div
            style={{
              fontSize: "13px"
            }}
          >

            API :
            {" "}
            {apiStatus}


          </div>



          <div
            style={{
              fontSize: "13px"
            }}
          >

            Editor :
            {" "}
            {editorStatus}


          </div>



          <div
            style={{
              fontSize: "12px",
              marginTop: "10px",
              color: "#666"
            }}
          >

            Server:
            <br />

            https://documentserver.ukwest.cloudapp.azure.com

          </div>


        </div>


      </div>







      {/* EDITOR AREA */}


      <div
        style={{
          flex: 1,
          display: "flex",
          flexDirection: "column"
        }}
      >


        {
          selectedFile ?

            <>


              <div
                style={{

                  height: "60px",
                  padding: "10px 20px",
                  borderBottom: "1px solid #ddd",
                  background: "#fff",
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center"

                }}
              >


                <div>

                  <b>
                    {selectedFile.name}
                  </b>


                  <div
                    style={{
                      fontSize: "12px",
                      color: "#666"
                    }}
                  >

                    Editing with OnlyOffice

                  </div>


                </div>




                <button

                  className="btn btn-outline-secondary btn-sm"

                  onClick={closeEditor}

                >

                  Close

                </button>


              </div>






              <div

                style={{
                  flex: 1,
                  background: "#f5f5f5"
                }}

              >


                <div

                  id="onlyoffice-editor"

                  style={{

                    width: "100%",
                    height: "100%",
                    display:
                      isEditorLoaded
                        ?
                        "block"
                        :
                        "block"

                  }}

                />


              </div>


            </>

            :



            <div

              className="d-flex justify-content-center align-items-center"

              style={{
                flex: 1,
                background: "#f8f9fa"
              }}

            >


              <div
                className="text-center"
              >

                <h3>
                  Select a Document
                </h3>


                <p
                  style={{
                    color: "#666"
                  }}
                >

                  Choose a document from left panel
                  to open in OnlyOffice.

                </p>


              </div>


            </div>


        }




        <div

          style={{

            height: "35px",
            borderTop: "1px solid #ddd",
            background: "#fff",
            textAlign: "center",
            fontSize: "12px",
            padding: "8px",
            color: "#666"

          }}

        >

          OnlyOffice Server:
          {" "}
          https://documentserver.ukwest.cloudapp.azure.com


        </div>



      </div>



    </div>


  );

};



export default OnlyOfficeEditor;